/**
 * PHARMAKON — Fournisseur ERP · PreviewBanner (Module 00, Appendix E.11)
 *
 * Token-styled upgrade banner shown above a gated surface rendered in PREVIEW
 * mode (real-but-limited data). Never a dead error page (DESIGN_DIRECTIVE §3.9).
 * Composed entirely from ERP V3 primitives + tokens — no hardcoded hex.
 *
 * TC-SUB-07 (Module 08): the « Activer » CTA is the upgrade seam — when no
 * `onUpgrade` override is given it navigates to the billing-portal Catalogue
 * with `?module=<code>` so the page highlights/scrolls to the plan(s) and the
 * à-la-carte card carrying the locked module. Callers may still pass their own
 * `onUpgrade` (the existing call sites do, pointing at the same URL).
 */
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Icon, Button } from "@/components/ui/primitives";
import { upgradeUrlForModule } from "@/config/fournisseur.constants.js";

export default function PreviewBanner({ module, onUpgrade }) {
  const navigate = useNavigate();
  const handleUpgrade = onUpgrade ?? (() => navigate(upgradeUrlForModule(module)));
  return (
    <div
      role="status"
      className="flex items-center gap-3 px-4 py-3 mb-4 rounded-lg border border-accent-line bg-accent-soft text-text-strong"
    >
      <span className="w-8 h-8 rounded-md bg-accent/15 text-accent flex items-center justify-center shrink-0">
        <Icon name="sparkles" size={16} />
      </span>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold">Aperçu limité</div>
        <p className="text-xs text-text-muted">
          Ce module n'est pas inclus dans votre abonnement. Vous consultez un
          aperçu limité{module ? ` du module « ${module} »` : ""}. Activez-le pour
          un accès complet.
        </p>
      </div>
      <Button variant="primary" size="sm" icon="arrow-up-circle" onClick={handleUpgrade}>
        Activer
      </Button>
    </div>
  );
}
